import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Abacies Logiciels</title>
        <meta name="description" content="The page you're looking for could not be found. Return to homepage or contact us for assistance." />
      </Helmet>

      <div className="min-h-screen bg-alabaster flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
          {/* 404 Illustration */}
          <div className="mb-8">
            <div className="relative inline-block">
              <div className="text-9xl md:text-[200px] font-bold text-primary-red opacity-10">404</div>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg className="w-32 h-32 md:w-48 md:h-48 text-primary-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Error Message */}
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4 animate-fade-in">
            Page Not Found
          </h1>
          <p className="text-xl text-titanium mb-8 animate-slide-up">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Suggestions */}
          <div className="bg-white rounded-lg p-6 mb-8 shadow-sm animate-slide-up" style={{ animationDelay: '0.1s' }}>
            <p className="text-titanium mb-4">Here are some helpful links:</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Link to="/" className="text-primary-red hover:underline">Home</Link>
              <Link to="/services" className="text-primary-red hover:underline">Services</Link>
              <Link to="/solutions" className="text-primary-red hover:underline">Solutions</Link>
              <Link to="/contact" className="text-primary-red hover:underline">Contact</Link>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <Link to="/" className="btn-primary">
              Return Home
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Support
            </Link>
          </div>

          {/* Additional Help */}
          <div className="mt-12 text-sm text-titanium animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <p>Error Code: 404 | If you believe this is a mistake, please contact us at</p>
            <a href="mailto:support@abacies.com" className="text-primary-red hover:underline">
              support@abacies.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
